import React from 'react';
import ServiceLandingPage, { ServiceConfig } from '../components/ServiceLandingPage';

const config: ServiceConfig = {
  name: 'Speaker & Mic Repair',
  icon: '🔊',
  tagline: 'Can\'t hear calls or your mic not working? Fixed at your doorstep.',
  description: 'Muffled audio, no sound during calls, or people unable to hear you? minto\'s technicians repair earpiece speakers, loudspeakers, and microphones for all major mobile brands — right at your doorstep across Mumbai. Most repairs are done in under an hour.',
  price: '399',
  warranty: '90-Day',
  benefits: [
    { icon: '🏠', title: 'Doorstep Service', desc: 'Technician comes to your location — home, office or café.' },
    { icon: '⚡', title: 'Same Day Repair', desc: 'Book before 6 PM and get your speaker or mic fixed today.' },
    { icon: '🛡️', title: '90-Day Warranty', desc: 'All speaker and mic repairs backed by 90 days warranty.' },
    { icon: '🔍', title: 'Accurate Diagnosis', desc: 'We identify whether it\'s a software or hardware issue before replacing parts.' },
    { icon: '📞', title: 'All Speaker Types', desc: 'Earpiece, loudspeaker, and microphone — all repaired.' },
    { icon: '💰', title: 'Transparent Pricing', desc: 'Price confirmed before we begin. No surprise charges.' },
  ],
  brands: ['iPhone', 'Samsung', 'OnePlus', 'Vivo', 'Oppo', 'Realme', 'Motorola', 'Xiaomi', 'Nothing', 'Google Pixel', 'Honor', 'Asus'],
  faqs: [
    { q: 'My speaker works sometimes but cuts out — is that repairable?', a: 'Yes, intermittent speaker issues are usually a loose connection or dust — both easily fixed.' },
    { q: 'Can you fix the mic so people can hear me on calls?', a: 'Yes, microphone repairs are one of our most common services.' },
    { q: 'How long does speaker or mic repair take?', a: 'Typically 30–45 minutes at your location.' },
    { q: 'Which areas in Mumbai do you cover?', a: 'We cover Andheri, Bandra, Dadar, Lower Parel, Borivali, Malad, Goregaon, Vile Parle, Ghatkopar, Kurla, Thane, Chembur and Navi Mumbai.' },
  ],
};

const SpeakerMicRepairPage: React.FC = () => <ServiceLandingPage config={config} />;
export default SpeakerMicRepairPage;
